"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.redirectWhenUserPropTrue = void 0;
const RouteInterceptor_1 = require("../RouteInterceptor");
/**
 * If the userProp is present and equal to "true" in the session, return a redirect action
 * @param userProp  The user prop to check for
 * @param to        Where to redirect to
 * @category Interceptor
 */
const redirectWhenUserPropTrue = (userProp, to) => ({ context }) => {
    if (!context.session)
        throw new Error("No session found. Have you executed this interceptor before authentication interceptor?");
    const user = context.session.user;
    if (user.properties[userProp] === "true") {
        return { kind: RouteInterceptor_1.RouteAction.REDIRECT, to: typeof to === "function" ? to(context) : to };
    }
    return null;
};
exports.redirectWhenUserPropTrue = redirectWhenUserPropTrue;
